module.exports = __webpack_public_path__ + "static/img/img32.b4dd510.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neighbourhood/img32.png
// module id = NTh0
// module chunks = 1